import { SupportAnnounce8Component } from "./SupportAnnounce8Component";

export function EntrepreneurAnnounce8FormComponent() {
    return (
        <SupportAnnounce8Component />
    );
}
